import {Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {FormularzUszkodzenService} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent} from '../base-lokalizacja-uszkodzen-z-parametry-przedmioty.component';
import {ParametryPowierzchni, ParametryZbioruUszkodzen} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {UszkodzeniaWLokalizacjiComponent} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';
import {SlownikRodzajElementu} from '../../../../../../../shared/model/rodzaj-elementu/slownikRodzajElementu';
import {ValidatorFn, Validators} from "@angular/forms";
import {isNumeric, max, min} from "../../../../../../../shared/validators/ControlValidators";

@Component({
  selector: 'app-elewacja',
  templateUrl: './elewacja.component.html'
})

export class ElewacjaComponent extends BaseLokalizacjaUszkodzenZParametryPrzedmiotyComponent implements OnInit, OnDestroy {

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService);
  }

  private readonly RODZAJ_ELEMENTU = SlownikRodzajElementu.ELEWACJA;

  public MINIMALNY_WYMIAR!: number;
  public MAKSYMALNY_WYMIAR!: number;

  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [SlownikUszkodzen.SCIANA_ZEWNETRZNA]
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.ELEWACJA;
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.slownikRodzajuElementu();
  }

  private slownikRodzajuElementu(): void {
    const {szerokosc, wysokosc} = this.formularzLokalizacjiUszkodzenia.controls;
    this.pobierzSlownikRodzajuElementow(
      this.RODZAJ_ELEMENTU,
      {
        next: (rodzajElementu => {
          this.MINIMALNY_WYMIAR = rodzajElementu.minimalnyWymiar;
          this.MAKSYMALNY_WYMIAR = rodzajElementu.maksymalnyWymiar;
          if (szerokosc && wysokosc) {
            szerokosc.setValidators(this.numberValidationFunction());
            wysokosc.setValidators(this.numberValidationFunction());
            szerokosc.updateValueAndValidity();
            wysokosc.updateValueAndValidity();
          }
        })
      }
    );
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen
    if (this.czyDataRemontuWymagana) {
      parametry.dataRemontu = this.formularzLokalizacjiUszkodzenia.controls.dataRemontu.value
    }
    const uszkodzeniaGrupowe = this.utworzUszkodzeniaGrupowe<ParametryPowierzchni>(this.uszkodzenia.toArray());

    uszkodzeniaGrupowe.forEach(u => u.rodzajElementu = this.RODZAJ_ELEMENTU)
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzeniaGrupowe);
    this.zapiszLiczbePieter(this.formularzLokalizacjiUszkodzenia.controls.liczbaPieter.value);
  }

  private numberValidationFunction(): ValidatorFn[] {
    return [
      Validators.required,
      min(this.MINIMALNY_WYMIAR),
      max(this.MAKSYMALNY_WYMIAR),
      isNumeric()
    ]
  }
}
